module.exports = __webpack_public_path__ + "media/applicants/yogurt4-78c78a5e.png";